import { render, staticRenderFns } from "./_avatar.vue?vue&type=template&id=2339da4f&scoped=true&"
import script from "./_avatar.vue?vue&type=script&lang=js&"
export * from "./_avatar.vue?vue&type=script&lang=js&"
import style0 from "./_avatar.vue?vue&type=style&index=0&id=2339da4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339da4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBadge,VBtn,VCard,VIcon})
